import { render, staticRenderFns } from "./LandParcelPredecessorsSuccessors.vue?vue&type=template&id=cc9ffe32&scoped=true&"
import script from "./LandParcelPredecessorsSuccessors.vue?vue&type=script&lang=js&"
export * from "./LandParcelPredecessorsSuccessors.vue?vue&type=script&lang=js&"
import style0 from "./LandParcelPredecessorsSuccessors.vue?vue&type=style&index=0&id=cc9ffe32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9ffe32",
  null
  
)

export default component.exports